module.exports = __webpack_public_path__ + "img/trainNumber.9224dd3e.png";